import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const TOrecursos = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="RECURSOS TERAPÊUTICOS /AMBIENTES DO SERVIÇO" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Recursos Terapêuticos" nome="torecursos" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="80vw" widthMobile="80vw" marginR="3vw" />
                    </div>

                    <CheckContainer>
                        <HeaderVerde texto="Sala/Espaços de Atendimento" />
                        <CheckBox texto="Climatizada " grupo="tosala" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Higienizada" grupo="tosala" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Organizada" grupo="tosala" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                        <CheckBox texto="Boa iluminação" grupo="tosala" modulo={modulo} index={n}
                            display="inline-grid" marginR="3vw" />
                    </CheckContainer>

                    <div style={{ textAlign: "left" }}>
                        <Select label="Sala Equipada para Treino de AVD" nome="toavd" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="14vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Sala Dispõe de Equipamentos Suspensos" nome="toequipamento" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="14vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>
                    <Observacoes widthWeb="83vw" widthMobile="80vw" modulo={modulo} index={n} nome="observacoes" />
                </Caixa>
            )
        }
        return partes
    }
}

export default TOrecursos